export default function notUserQ(recordType) {
  const lc = recordType.toLowerCase()
  return lc === 'district' || lc === 'school' || lc === 'class'
}


// WEBPACK FOOTER //
// ./src/helpers/users/manageUsers/notUserQ.js